import { Observable } from "rxjs";
import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";
import { PageRequest } from "src/app/support/page-request";
import { Backup } from "src/app/modules/bootstrap/rocket-ui/backend/models/backup";
import { isUndefined, omitBy } from "lodash-es";

@Injectable()
export class BackupBackend {
  private readonly http = inject(HttpClient);

  search(request: PageRequest): Observable<PaginatedResult<Backup>> {
    return this.http.get<PaginatedResult<Backup>>(
      `${environment.snoots.api.diagnostic}/backups`,
      {
        params: <any>omitBy(
          {
            p: request.page,
            s: request.pageSize,
            ...request.filterValues
          },
          isUndefined
        )
      }
    );
  }
}
